import notify from '../../../utils/notify';

export const createLockRespondHandler =
  lockResponse =>
  async (responseId, isLocked = true, finalValue = null) => {
    try {
      await lockResponse(responseId, isLocked, finalValue);
      notify.success(
        isLocked
          ? 'Marked as agreed successfully.'
          : 'Agreement unlocked successfully.'
      );
      return true;
    } catch (error) {
      notify.apiError(
        error,
        isLocked ? 'mark as agreed' : 'unlock the agreement'
      );
      return false;
    }
  };
